import { SavingFormValues } from "./types";

export const FORM_ID = "saving";

export const DEFAULT_SAVING: SavingFormValues = {
  name: "",
  institution: "",
  startDate: new Date(),
};
